// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__xKg2O","log":"ModalInventoryLogs_log__bEsNq","date":"ModalInventoryLogs_date__21Qyr","userName":"ModalInventoryLogs_userName__3nNJ4"};